import { render } from "./MultiCheckboxField.vue?vue&type=template&id=1f31d478"
import script from "./MultiCheckboxField.vue?vue&type=script&lang=js"
export * from "./MultiCheckboxField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__